/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import React, { useState } from 'react';
import Navbar from '../../Components/Navbar/Navbar';
import Sidebar from '../../Components/Sidebar/Sidebar';
import noImage from '../../Images/photo-camera.png';
import './New.scss';
import axios from 'axios';
import { Cloudinary } from "@cloudinary/url-gen";
import { motion, AnimatePresence } from 'framer-motion';
import { Upload } from 'lucide-react';

// Initialize Cloudinary URL generator outside the component
const cld = new Cloudinary({ cloud: { cloudName: 'dwpoik1jm' } });


function AddNew({ titlee }) {
    const [isLoading, setIsLoading] = useState(false);
    const [toast, setToast] = useState({ show: false, message: '', type: '' });
    const [productData, setProductData] = useState({
        producttitle: '',
        productdescription: '',
        productprice: '',
        productunitssold: '',
        productunitsleft: '',
        productlocation: '',
        directcommission: '',
        inDirectcommission: "",
    });
    const [file, setFile] = useState(null);
    const [file2, setFile2] = useState(null);
    const [imageUrl, setImageUrl] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setProductData({
            ...productData,
            [name]: value
        });
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files;
        const imageUrl = selectedFile[0];
        console.log("Selected File:", selectedFile);
        const selectedFilefordisplay = e.target.files[0];
        const imageUrldisplay = URL.createObjectURL(selectedFilefordisplay);

        // Create FormData object
        const formData = new FormData();

        // Append the selected file to the FormData object
        formData.append('file', imageUrl);
        formData.append('upload_preset', 'giweexpv'); // Replace with your Cloudinary upload preset
        console.log(formData);
        // Set the files state with the FormData object
        setFile(formData);

        setImageUrl(imageUrldisplay);
    };

    const handleFile2Change = (e) => {
        const selectedFile = e.target.files;
        const formfile = selectedFile[0];
        console.log("Selected File:", selectedFile);
        // const selectedFilefordisplay = e.target.files[0];
        // const imageUrldisplay = URL.createObjectURL(selectedFilefordisplay);

        // Create FormData object
        const formData = new FormData();

        // Append the selected file to the FormData object
        formData.append('file', formfile);
        formData.append('upload_preset', 'giweexpv'); // Replace with your Cloudinary upload preset
        console.log(formData);
        // Set the files state with the FormData object
        setFile2(formData);

        // setImageUrl(imageUrldisplay);
    };

    const showToast = (message, type = 'success') => {
        setToast({ show: true, message, type });
        setTimeout(() => setToast({ show: false, message: '', type: '' }), 3000);
    };


    const updateProductInDatabase = async () => {
        setIsLoading(true);

        try {
            let imageUrll

            // Check if a new file is selected
            if (file) {
                // Upload the new image to Cloudinary
                const response = await axios.post('https://api.cloudinary.com/v1_1/dwpoik1jm/image/upload', file);

                imageUrll = response.data.secure_url; // Get the URL of the uploaded image from the Cloudinary response
            }
            console.log(imageUrll)

            let formfile

            // Check if a new file is selected
            if (file2) {
                // Upload the new image to Cloudinary
                const response = await axios.post('https://api.cloudinary.com/v1_1/dwpoik1jm/image/upload', file2);

                formfile = response.data.secure_url; // Get the URL of the uploaded image from the Cloudinary response
            }
            console.log(formfile)

            const updatedData = {
                producttitle: productData.producttitle,
                productdescription: productData.productdescription,
                productprice: productData.productprice,
                productunitssold: productData.productunitssold,
                productunitsleft: productData.productunitsleft,
                productlocation:   productData.productlocation,
                directcommission: productData.directcommission,
                inDirectcommission: productData.inDirectcommission,
                productimage: imageUrll,
                productformfile: formfile,  // Changed to imageUrls which is an array of URLs
            };

            await axios.post(
                // 'http://localhost:3005/admin/api/add-product',
                'https://portal-sanieldanproperties-api.onrender.com/admin/api/add-product',
                updatedData);
                showToast('Product added successfully!', 'success');
            } catch (error) {
                showToast('Failed to add product. Please try again.', 'error');
            } finally {
                setIsLoading(false);
            }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        updateProductInDatabase()
      };

      return (
        <>
        <Sidebar />
        
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-4xl mx-auto p-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="bg-white rounded-lg shadow-lg p-8"
                >
                    <h1 className="text-2xl font-bold text-gray-800 mb-8">{titlee}</h1>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        {/* Image Upload Section */}
                        <div className="flex flex-col items-center mb-8">
                            <div className="w-32 h-32 rounded-full overflow-hidden border-2 border-gray-200 relative mb-4">
                                <img
                                    src={imageUrl || 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"><rect width="100" height="100" fill="%23f0f0f0"/></svg>'}
                                    alt="Product"
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <label className="cursor-pointer bg-blue-50 hover:bg-blue-100 text-blue-600 px-4 py-2 rounded-md transition-colors">
                                <Upload className="inline mr-2" size={20} />
                                Upload Image
                                <input
                                    type="file"
                                    className="hidden"
                                    onChange={handleFileChange}
                                    accept="image/*"
                                />
                            </label>
                        </div>

                        {/* Form Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* Product Title */}
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Product Title</label>
                                <input
                                    type="text"
                                    name="producttitle"
                                    value={productData.producttitle}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    required
                                />
                            </div>

                            {/* Price */}
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Price</label>
                                <input
                                    type="text"
                                    name="productprice"
                                    value={productData.productprice}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    required
                                />
                            </div>

                            {/* Description */}
                            <div className="space-y-2 md:col-span-2">
                                <label className="text-sm font-medium text-gray-700">Description</label>
                                <textarea
                                    name="productdescription"
                                    value={productData.productdescription}
                                    onChange={handleInputChange}
                                    rows="3"
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    required
                                />
                            </div>

                            {/* Units Sold */}
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Units Sold</label>
                                <input
                                    type="number"
                                    name="productunitssold"
                                    value={productData.productunitssold}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    required
                                />
                            </div>

                            {/* Units Left */}
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Units Left</label>
                                <input
                                    type="number"
                                    name="productunitsleft"
                                    value={productData.productunitsleft}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    required
                                />
                            </div>

                            {/* Location */}
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Location</label>
                                <input
                                    type="text"
                                    name="productlocation"
                                    value={productData.productlocation}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    required
                                />
                            </div>

                            {/* Percentage */}
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">Direct Commission</label>
                                <input
                                    type="number"
                                    name="directcommission"
                                    value={productData.directcommission}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    required
                                />
                            </div>

                             {/* Percentage */}
                             <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700">InDirect Commission</label>
                                <input
                                    type="number"
                                    name="inDirectcommission"
                                    value={productData.inDirectcommission}
                                    onChange={handleInputChange}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    required
                                />
                            </div>

                            <div>
                                <label htmlFor="file2">
                                    Upload Product Form:
                                </label>
                                <input
                                    type="file"
                                    name="file2"
                                    id="file2"

                                    onChange={handleFile2Change}
                                />
                            </div>

                            

                        </div>

                        {/* Submit Button */}
                        <div className="flex justify-end">
                            <button
                                type="submit"
                                disabled={isLoading}
                                className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                            >
                                {isLoading ? (
                                    <div className="flex items-center">
                                        <div className="w-5 h-5 border-t-2 border-white border-solid rounded-full animate-spin mr-2"></div>
                                        Saving...
                                    </div>
                                ) : 'Save Changes'}
                            </button>
                        </div>
                    </form>
                </motion.div>

                {/* Toast Notification */}
                <AnimatePresence>
                    {toast.show && (
                        <motion.div
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 50 }}
                            className={`fixed bottom-4 right-4 px-6 py-3 rounded-lg shadow-lg ${
                                toast.type === 'success' ? 'bg-green-500' : 'bg-red-500'
                            } text-white`}
                        >
                            {toast.message}
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </div>
        </>
    );
}

export default AddNew;